/* ==================================================================
   La ligne de voix sous chaque famille du tiroir, 2026-09-21
   ==================================================================
   Julien : « je trouve ca archi fade, il me faut vraiment un site
   original. » La voix est le seul differenciant que les trois concurrents
   ne peuvent pas copier : aucun n'en a nulle part.
   Voir l'exigence d'originalite en tete de charte-graphique.md.

   ⚠️ CHAQUE PHRASE EST UN FAIT VERIFIE SUR LA BOUTIQUE, pas un slogan.
   121 sextoys, 62 produits hors jouet, 16 jeux, 8 references pour
   commencer, 5 collections de marque. Releve le 2026-09-21.
   Une phrase qui deviendrait fausse doit etre corrigee ici.
   ================================================================== */
(function () {
  var VOIX = {
    'Sextoys':          'On explique ce que fait chacun.',
    'Bien-etre':        "Rien ici n'est un jouet.",
    'Bien-être':        "Rien ici n'est un jouet.",
    'Jeux et coffrets': 'Pour rire avant.',
    'Marques':          'Cinq maisons, pas cinq mille.',
    'Pour commencer':   "Si vous n'avez jamais essayé."
  };

  function pret(f) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', f);
    else f();
  }

  pret(function () {
    var tiroir = document.getElementById('menu-drawer');
    if (!tiroir) return;
    var sommaires = tiroir.querySelectorAll('summary.menu-drawer__menu-item');
    for (var i = 0; i < sommaires.length; i++) {
      var s = sommaires[i];
      if (s.querySelector('.tm-voix')) continue;

      /* Le libelle est fait des noeuds de texte du sommaire : les
         span.svg-wrapper des fleches ne comptent pas. */
      var nom = '';
      for (var n = 0; n < s.childNodes.length; n++) {
        if (s.childNodes[n].nodeType === 3) nom += s.childNodes[n].textContent;
      }
      nom = nom.replace(/\s+/g, ' ').trim();

      var phrase = VOIX[nom];
      if (!phrase) continue;          /* famille inconnue : on n'invente rien */

      var ligne = document.createElement('span');
      ligne.className = 'tm-voix';
      ligne.textContent = phrase;
      s.appendChild(ligne);
      s.classList.add('tm-avec-voix');
    }
  });
})();
